/**
 * Auto-generated types from VoteBox API
 *
 * Generated from API version: latest
 * Generation date: 2025-12-11T19:58:27.526Z
 *
 * DO NOT EDIT THIS FILE MANUALLY
 * Run 'npm run generate-types' to regenerate
 */

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface VoteSubmitDto {
  /**
   * Original transaction hash
   * @example "a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6q7r8s9t0u1v2w3x4y5z6a7b8c9d0e1f2"
   */
  originalTxHash: string
  /**
   * Transaction amount (decimal string)
   * @example "1.5"
   */
  amount: string
  /**
   * Processing status
   * @example "RECEIVED"
   */
  status: VoteSubmitDtoStatusEnum
  /**
   * TON amount staked (in nanotons)
   * @example "1000000000"
   */
  tonStake: string
  /**
   * Creation timestamp in milliseconds
   * @example "1640000000000"
   */
  createdAt: string
  /**
   * Last update timestamp in milliseconds
   * @example "1640000000000"
   */
  updatedAt: string
}

export interface UserVoteSummaryDto {
  /**
   * Total votes in nanotons
   * @example "2900000000"
   */
  totalVotes: string
  /**
   * Total TON staked in nanotons
   * @example "2900000000"
   */
  totalTonStaked: string
  /**
   * Current wallet votes balance in nanotons
   * @example "0"
   */
  walletVotes: string
  /**
   * Status of user vote summary
   * @example "CLAIMED"
   */
  status: UserVoteSummaryDtoStatusEnum
  /**
   * Status sync state
   * @example "SYNCED"
   */
  statusSyncState: UserVoteSummaryDtoStatusSyncStateEnum
  /**
   * Votes sync state
   * @example "SYNCED"
   */
  votesSyncState: UserVoteSummaryDtoVotesSyncStateEnum
  /**
   * Last sync timestamp in milliseconds
   * @example "1761809600506"
   */
  lastSyncAt: string | null
  /**
   * Votes sync error message
   * @example null
   */
  syncErrorVotes: string | null
  /**
   * Status sync error message
   * @example null
   */
  syncErrorStatus: string | null
  /**
   * Creation timestamp in milliseconds
   * @example "1761809600506"
   */
  createdAt: string
  /**
   * Last update timestamp in milliseconds
   * @example "1761809600506"
   */
  updatedAt: string
  /** Array of non-accepted vote transactions sent by the user (pending or failed) */
  votesSubmitted?: VoteSubmitDto[]
}

export interface BoxChoiceDto {
  /**
   * Choice text
   * @example "Да, в 2025"
   */
  choice: string
  /**
   * Choice index
   * @example 0
   */
  choiceIndex: number
  /**
   * Total vote count in nanotons
   * @example "0"
   */
  voteCount: string
  /**
   * Total TON staked in nanotons
   * @example "0"
   */
  tonStaked: string
  /**
   * Jetton master contract address
   * @example "0:05f97feb6dd4b6e7bb022e24f7f4d0078f9861ee8f39f89789e290fb7d571c20"
   */
  jettonMasterAddress: string
  /**
   * Jetton master status (-1 = not deployed, 1 = deployed)
   * @example -1
   */
  jettonMasterStatus: number
  /**
   * Estimated potential return for 1 TON
   * @example null
   */
  estimatedPotentialReturnFor1Ton: string | null
  /**
   * Creation timestamp
   * @example "1761805652688"
   */
  createdAt: string
  /**
   * Last update timestamp
   * @example "1761809975947"
   */
  updatedAt: string
  /** User vote summary for this choice (null if user has not voted on this choice) */
  user_vote_summary: UserVoteSummaryDto | null
}

export interface BoxDto {
  /**
   * Box ID
   * @example 86
   */
  id: number
  /**
   * Box contract address
   * @example "0:f4bd7bafe738c48db7f288899107e9e6750dd7f3bf3b731e85056e4ac0e916ba"
   */
  address: string
  /**
   * Transaction hash
   * @example "3ae4f827dfa40e02aa53b5ea1f9cef340b46e2afd4d5d83f9a76ecba0d29a31b"
   */
  transactionHash: string
  /**
   * Master collection address
   * @example "0:efbe4a205d22256155a9d94be537d7c398b8dc3e663c24a392f4156ad0483cf7"
   */
  masterCollectionAddress: string
  /**
   * NFT item index
   * @example "78"
   */
  itemIndex: string
  /**
   * Box owner address
   * @example "0:d0cd4f3b79655de5058118a073e89c887c0972baabbdd802b283a84eb6d514b2"
   */
  owner: string
  /**
   * Box question
   * @example "Выпустит ли Apple AR-очки в 2025 году?"
   */
  question: string
  /**
   * Box status (2 = VOTING_OPEN, 3 = VOTING_PREFINISHED, 4 = VOTING_FINISHED, 5 = REWARDS_DISTRIBUTED)
   * @example 2
   */
  boxStatus: number
  /**
   * Winner choice index (null if not finished)
   * @example null
   */
  winner: number | null
  /**
   * Minimum TON stake in nanotons
   * @example "500000000"
   */
  minTonStake: string
  /**
   * Maximum TON stake in nanotons
   * @example "20000000000"
   */
  maxTonStake: string
  /**
   * Display in feed
   * @example true
   */
  feedDisplay: boolean
  /**
   * Passed moderation
   * @example true
   */
  passedModeration: boolean
  /**
   * Language code
   * @example "en"
   */
  lang: string
  /**
   * Image URL
   * @example "https://static.testnet.votebox.io/bot/apple_release_ar_glasses_in_2025.png"
   */
  imageUrl: string
  /**
   * Start time in milliseconds
   * @example "1761783478000"
   */
  startTime: string
  /**
   * End time (deadline) in milliseconds
   * @example "1761956271000"
   */
  endTime: string
  /**
   * Platform fee in basis points
   * @example "200"
   */
  platformBasisPoints: string
  /**
   * Creator fee in basis points
   * @example "1000"
   */
  creatorBasisPoints: string
  /**
   * Recommended vote gas in nanotons
   * @example "150000000"
   */
  recommendedVoteGas: string
  /**
   * Number of unique users who voted for this box
   * @example 42
   */
  votedUsersCount: number
  /**
   * Creation timestamp
   * @example "1761805652688"
   */
  createdAt: string
  /**
   * Last update timestamp
   * @example "1761809975947"
   */
  updatedAt: string
  /** Array of box choices */
  boxChoices: BoxChoiceDto[]
}

export interface BoxMetaDto {
  /**
   * Total number of items
   * @example 100
   */
  total: number
  /**
   * Items per page
   * @example 10
   */
  limit: number
  /**
   * Current page number
   * @example 1
   */
  page: number
  /**
   * Total number of pages
   * @example 10
   */
  totalPages: number
  /**
   * Status filter applied
   * @example "all"
   */
  status: BoxMetaDtoStatusEnum
  /**
   * Owner filter applied (normalized wallet address)
   * @example null
   */
  owner: string | null
}

export interface FindAllBoxesResponseDto {
  /** Array of boxes */
  data: BoxDto[]
  /** Pagination metadata */
  meta: BoxMetaDto
}

export interface BoxCollectionDto {
  /**
   * Address of the box collection contract
   * @example "0:abc123..."
   */
  address: string
  /**
   * Version of the box collection
   * @example 0
   */
  version: number
  /**
   * Status of the box collection
   * @example 3
   */
  status: BoxCollectionDtoStatusEnum
  /**
   * Timestamp when created (milliseconds)
   * @example "1640000000000"
   */
  createdAt: string
  /**
   * Timestamp when last updated (milliseconds)
   * @example "1640000000000"
   */
  updatedAt: string
}

export interface FindAllBoxCollectionsResponseDto {
  /** Array of box collections */
  data: BoxCollectionDto[]
}

export interface UserResponseDto {
  /**
   * User wallet address
   * @example "EQTest123456789"
   */
  walletAddress: string
  /**
   * Unique referral key for this user
   * @example "KEY_ABC123"
   */
  referralKey: string
  /**
   * Wallet address of the user who referred this user
   * @example "EQReferrer123"
   */
  referredByWalletAddress?: string | null
  /**
   * Telegram user ID
   * @example "123456789"
   */
  tgUserId?: string | null
  /**
   * Generated display name for the user
   * @example "abstract orange panda"
   */
  displayName: string
  /**
   * User creation timestamp in milliseconds
   * @example "1640000000000"
   */
  createdAt: string
  /**
   * Current bonus rewards in nanotons
   * @example "0"
   */
  currentBonusRewards: string
  /**
   * Total bonus rewards earned in nanotons
   * @example "0"
   */
  totalBonusRewards: string
  /**
   * In-flight (pending) bonus rewards in nanotons
   * @example "0"
   */
  inFlightBonusRewards: string
  /**
   * Total value locked (TVL) in nanotons
   * @example "5000000000"
   */
  tvl: string
  /**
   * Total unclaimed vote count
   * @example "100"
   */
  unclaimedVoteCount: string
}

export interface UserVoteSummaryMetaDto {
  /**
   * Total number of items
   * @example 100
   */
  total: number
  /**
   * Items per page
   * @example 10
   */
  limit: number
  /**
   * Current page number
   * @example 1
   */
  page: number
  /**
   * Total number of pages
   * @example 10
   */
  totalPages: number
}

export interface UserVoteSummariesResponseDto {
  /** Array of boxes with user vote summaries */
  data: BoxDto[]
  /** Pagination metadata */
  meta: UserVoteSummaryMetaDto
}

export interface CreatedBoxesMetaDto {
  /**
   * Total number of items
   * @example 100
   */
  total: number
  /**
   * Items per page
   * @example 10
   */
  limit: number
  /**
   * Current page number
   * @example 1
   */
  page: number
  /**
   * Total number of pages
   * @example 10
   */
  totalPages: number
  /**
   * Order by field used
   * @example "created_at"
   */
  orderBy: CreatedBoxesMetaDtoOrderByEnum
  /**
   * Order direction used
   * @example "desc"
   */
  orderDirection: CreatedBoxesMetaDtoOrderDirectionEnum
}

export interface CreatedBoxesResponseDto {
  /** Array of boxes created by the user (includes user_vote_summary with claimsSubmitted if user voted) */
  data: BoxDto[]
  /** Pagination and ordering metadata */
  meta: CreatedBoxesMetaDto
}

export interface TransactionSentDto {
  /**
   * User wallet address
   * @example "0:b539646341998654d0252db72f741a4e46933880081c81936e53dfe87941e579"
   */
  userAddress: string
  /**
   * Destination address where transaction is being sent
   * @example "0:1234567890abcdef1234567890abcdef1234567890abcdef1234567890abcdef"
   */
  address: string
  /**
   * Transaction amount in nanotons
   * @example "1.5"
   */
  amount: string
  /**
   * Base64-encoded BOC (Bag of Cells) containing the full transaction. Used to extract transaction hash.
   * @example "te6cckEBAQEAFQAAJXMIi6YAAAGaPbfalgABQ7msoAiU0tPH"
   */
  boc: string
  /**
   * Base64-encoded payload (message body) to parse. Used to determine transaction type and extract message data.
   * @example "te6cckEBAQEAFQAAJXMIi6YAAAGaPbfalgABQ7msoAiU0tPH"
   */
  payload: string
}

export interface VoteSubmitResponseDto {
  /**
   * Internal ID
   * @example 1
   */
  id: number
  /**
   * User wallet address
   * @example "0:b539646341998654d0252db72f741a4e46933880081c81936e53dfe87941e579"
   */
  userWalletAddress: string
  /**
   * Original transaction hash
   * @example "a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6q7r8s9t0u1v2w3x4y5z6a7b8c9d0e1f2"
   */
  originalTxHash: string
  /**
   * Destination address where transaction was sent
   * @example "0:1234567890abcdef1234567890abcdef1234567890abcdef1234567890abcdef"
   */
  toAddress: string
  /**
   * Transaction amount (decimal string)
   * @example "1.5"
   */
  amount: string
  /**
   * Processing status
   * @example "RECEIVED"
   */
  status: VoteSubmitResponseDtoStatusEnum
  /**
   * Creation timestamp in milliseconds
   * @example "1640000000000"
   */
  createdAt: string
  /**
   * Last update timestamp in milliseconds
   * @example "1640000000000"
   */
  updatedAt: string
  /**
   * Foreign key to BoxChoice
   * @example 1
   */
  boxChoiceId: number
  /**
   * Query ID from Vote message
   * @example "123456789"
   */
  queryId: string
  /**
   * TON amount staked (in nanotons)
   * @example "1000000000"
   */
  tonStake: string
}

export interface BonusReferralsDto {
  /** @example 5 */
  totalCount: number
  /** @example 3 */
  activeCount: number
}

export interface BonusStatsDto {
  /**
   * Total earned in nanotons
   * @example "1000000000"
   */
  totalEarned: string
  /**
   * Available to withdraw in nanotons
   * @example "500000000"
   */
  canWithdraw: string
  /**
   * In-flight (pending) rewards in nanotons
   * @example "0"
   */
  inFlight: string
  referrals: BonusReferralsDto
}

export interface TaskProgressDto {
  /** @example 1 */
  current: number
  /** @example 5 */
  target: number
}

export interface UserTaskDto {
  /** @example "first_vote" */
  taskKey: string
  /** @example "First Vote" */
  titleEn: string
  /** @example "Первый голос" */
  titleRu: string
  /** @example "Make your first vote" */
  descriptionEn: string
  /** @example "Сделайте первый голос" */
  descriptionRu: string
  /**
   * Reward in nanotons
   * @example "100000000"
   */
  reward: string
  /** @example "completed" */
  status: UserTaskDtoStatusEnum
  progress?: TaskProgressDto | null
  /** @example 1640000000000 */
  completedAt?: number | null
}

export interface UserTasksResponseDto {
  tasks: UserTaskDto[]
}

export interface ReferralUserDto {
  /** @example "EQRe...123" */
  walletAddressShort: string
  /** @example "abstract orange panda" */
  displayName: string
  /** @example 1640000000000 */
  joinedAt: number
  /**
   * Total earnings in nanotons
   * @example "50000000"
   */
  totalEarnings: string
  /** @example 10 */
  voteCount: number
  /**
   * Timestamp of last vote in milliseconds, null if never voted
   * @example 1640000000000
   */
  lastActiveAt: number | null
}

export interface OffsetPaginationDto {
  /**
   * Total number of items
   * @example 100
   */
  total: number
  /**
   * Items per page
   * @example 10
   */
  limit: number
  /**
   * Offset of current result set
   * @example 0
   */
  offset: number
  /**
   * Whether more items are available
   * @example true
   */
  hasMore: boolean
}

export interface ReferralsSummaryDto {
  /** @example 100 */
  totalReferrals: number
  /** @example 75 */
  activeReferrals: number
  /**
   * Total earnings in nanotons
   * @example "5000000000"
   */
  totalEarnings: string
}

export interface ReferralsResponseDto {
  referrals: ReferralUserDto[]
  pagination: OffsetPaginationDto
  summary: ReferralsSummaryDto
}

export interface ClaimRequestDto {
  /** @example 1 */
  id: number
  /**
   * Claim amount in nanotons
   * @example "5000000000"
   */
  claimAmount: string
  /** @example "REQUESTED" */
  claimState: string
  /** @example 1640000000000 */
  createdAt: number
}

export interface ClaimRewardsResponseDto {
  claimRequest: ClaimRequestDto
}

export interface GeneratePayloadResponseDto {
  /**
   * Short-lived JWT token (15 min)
   * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
   */
  payloadToken: string
  /**
   * SHA256 hash to be signed by wallet (hex, 64 chars)
   * @example "a7f3d9e8c4b2a1f5e6d8c9b7a3f2d1e8c5b6a7f8d9e0c1b2a3f4d5e6c7b8a9f0"
   */
  payload: string
}

export interface TonProofDomainDto {
  /**
   * Domain string length in bytes
   * @example 11
   */
  lengthBytes: number
  /**
   * Domain value
   * @example "votebox.io"
   */
  value: string
}

export interface TonProofDto {
  /**
   * Unix timestamp when proof was created (seconds)
   * @example 1698765432
   */
  timestamp: number
  /** Domain that requested the proof */
  domain: TonProofDomainDto
  /**
   * Base64 encoded Ed25519 signature (88 chars)
   * @example "base64EncodedSignature=="
   */
  signature: string
  /**
   * Hex payload from generate-payload endpoint
   * @example "a7f3d9e8c4b2a1f5e6d8c9b7a3f2d1e8c5b6a7f8d9e0c1b2a3f4d5e6c7b8a9f0"
   */
  payload: string
  /**
   * Base64 encoded wallet state_init
   * @example "te6cckEBAQEA..."
   */
  state_init: string
}

export interface CheckProofDto {
  /**
   * TON wallet address (format: workchain:hash)
   * @example "0:a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2"
   */
  address: string
  /**
   * Hex public key (64 chars)
   * @example "a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2"
   */
  public_key: string
  /** TON Connect proof */
  proof: TonProofDto
  /**
   * JWT from generate-payload endpoint
   * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
   */
  payloadToken: string
  /**
   * Telegram user ID (optional)
   * @example "123456789"
   */
  tgUserId?: string
  /**
   * Referral key of the user who referred this user (optional)
   * @example "KEY_ABC123"
   */
  referredByKey?: string
}

export interface AuthUserDto {
  /**
   * User wallet address
   * @example "0:a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2"
   */
  walletAddress: string
  /**
   * Unique referral key for this user
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  referralKey: string
}

export interface AuthResponseDto {
  /**
   * Long-lived JWT token (7 days)
   * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
   */
  token: string
  /** Authenticated user information */
  user: AuthUserDto
}

/**
 * Processing status
 * @example "RECEIVED"
 */
export enum VoteSubmitDtoStatusEnum {
  RECEIVED = 'RECEIVED',
  PROCESSING = 'PROCESSING',
  INITIAL_FAILED = 'INITIAL_FAILED',
  CHILD_FAILED = 'CHILD_FAILED',
  ACCEPTED = 'ACCEPTED',
  NOT_FOUND = 'NOT_FOUND',
}

/**
 * Status of user vote summary
 * @example "CLAIMED"
 */
export enum UserVoteSummaryDtoStatusEnum {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  UNCLAIMED = 'UNCLAIMED',
  CLAIMED = 'CLAIMED',
  LOSER = 'LOSER',
}

/**
 * Status sync state
 * @example "SYNCED"
 */
export enum UserVoteSummaryDtoStatusSyncStateEnum {
  SYNCED = 'SYNCED',
  NOT_SYNCED = 'NOT_SYNCED',
}

/**
 * Votes sync state
 * @example "SYNCED"
 */
export enum UserVoteSummaryDtoVotesSyncStateEnum {
  SYNCED = 'SYNCED',
  NOT_SYNCED = 'NOT_SYNCED',
}

/**
 * Status filter applied
 * @example "all"
 */
export enum BoxMetaDtoStatusEnum {
  All = 'all',
  Active = 'active',
  Finished = 'finished',
}

/**
 * Status of the box collection
 * @example 3
 */
export enum BoxCollectionDtoStatusEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

/**
 * Order by field used
 * @example "created_at"
 */
export enum CreatedBoxesMetaDtoOrderByEnum {
  BoxStatus = 'box_status',
  CreatedAt = 'created_at',
  Deadline = 'deadline',
}

/**
 * Order direction used
 * @example "desc"
 */
export enum CreatedBoxesMetaDtoOrderDirectionEnum {
  Asc = 'asc',
  Desc = 'desc',
}

/**
 * Processing status
 * @example "RECEIVED"
 */
export enum VoteSubmitResponseDtoStatusEnum {
  RECEIVED = 'RECEIVED',
  PROCESSING = 'PROCESSING',
  INITIAL_FAILED = 'INITIAL_FAILED',
  CHILD_FAILED = 'CHILD_FAILED',
  ACCEPTED = 'ACCEPTED',
  NOT_FOUND = 'NOT_FOUND',
}

/** @example "completed" */
export enum UserTaskDtoStatusEnum {
  Pending = 'pending',
  InProgress = 'in_progress',
  Completed = 'completed',
}

/** Filter by box status: all (default), active (voting open), finished (voting closed) */
export enum BoxesControllerFindAllParamsStatusEnum {
  All = 'all',
  Active = 'active',
  Finished = 'finished',
}

/** Field to order by (default: created_at) */
export enum BoxesControllerFindAllParamsOrderByEnum {
  CreatedAt = 'created_at',
  Deadline = 'deadline',
}

/** Order direction (default: desc) */
export enum BoxesControllerFindAllParamsOrderDirectionEnum {
  Asc = 'asc',
  Desc = 'desc',
}

/**
 * Filter by box collection status (0=deploy_failed, 1=deploy_pending, 2=deployed, 3=active, 4=close_only, 5=archived)
 * @example 3
 */
export enum BoxesControllerFindAllCollectionsParamsStatusEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

/** Field to order by (default: version) */
export enum BoxesControllerFindAllCollectionsParamsOrderByEnum {
  Version = 'version',
}

/** Order direction (default: desc) */
export enum BoxesControllerFindAllCollectionsParamsOrderDirectionEnum {
  Asc = 'asc',
  Desc = 'desc',
}

/** Order direction */
export enum AuthenticatedUserControllerGetUserVotesParamsOrderDirectionEnum {
  Asc = 'asc',
  Desc = 'desc',
}

/** Field to order by. "deadline" sorts by box end time. "activity" sorts by most recent user vote summary update (max updatedAt across all choices in each box). */
export enum AuthenticatedUserControllerGetUserVotesParamsOrderByEnum {
  Deadline = 'deadline',
  Activity = 'activity',
}

/** Field to order by */
export enum AuthenticatedUserControllerGetCreatedBoxesParamsOrderByEnum {
  BoxStatus = 'box_status',
  CreatedAt = 'created_at',
  Deadline = 'deadline',
}

/** Order direction (ascending or descending) */
export enum AuthenticatedUserControllerGetCreatedBoxesParamsOrderDirectionEnum {
  Asc = 'asc',
  Desc = 'desc',
}
